export const RenderView = (View, props) =>
  View ? <View {...props} /> : <> </>;

export default RenderView;
